export default __webpack_public_path__ + "static/media/ceramic-coating-1.f45c929e.webp";